import { getMaintenanceScheduleState } from '../reducers';
import { createSelector } from '@ngrx/store';
import * as fromSchedules from '../reducers/maintenance-schedule.reducer';

export const getSchedules = () =>
  createSelector(getMaintenanceScheduleState, fromSchedules.getSchedules);
export const getTooltipSchedules = () =>
  createSelector(
    getMaintenanceScheduleState,
    fromSchedules.getTooltipSchedules,
  );
export const getSchedulesAlerts = () =>
  createSelector(getMaintenanceScheduleState, fromSchedules.getSchedulesAlerts);

export const getSchedulesLoading = () =>
  createSelector(
    getMaintenanceScheduleState,
    fromSchedules.getSchedulesLoading,
  );

export const getScheduleError = () =>
  createSelector(getMaintenanceScheduleState, fromSchedules.getScheduleError);
